import React, {Component} from 'react';
import Select from '../Select/Select';
import BlankComponent from '../BlankComponent/BlankComponent';
import Skeleton from "../Skeleton/Skeleton";
import PropTypes from 'prop-types';
import moment from 'moment';
import ContentRenderer from "../ContentRenderer/ContentRenderer";
import ContentLinkRenderer from "../ContentLinkRenderer/ContentLinkRenderer";

/**
 * CardsList Component is Layout Component used to render Dynamic Content Page.
 *
 * There're three main variations:
 *
 * 1. "Awards" Page that uses Cards view with ability to swith to a List view. In this case List View will show archived items.
 * 2. "Press Releases" Page that uses list view by default, with ability to switch to another list view which shows only archived items.
 * 3. "News" page that has only list view without ability to switch to Archived view
 *
 */

class CardsList extends Component {
  
  state = {
    selectedFilter: 'Most Recent',
  };
  
  handleChange = (event) => {
    this.setState({
      selectedFilter: event.target.value
    })
  };
  
  getCardsView = () => {
  
    if (!this.props.layoutData) {
      return <Skeleton type="LONG_CONTENT_PAGE" />
    }
    return (
      <div>
        <div className="fg fg--box-wrapper">
          {
            this.props.layoutData
              .filter((item) => {
                return !item.archived
              })
              .map((item, index) => {
                return (
                  <div key={index} className="fg__col-lg-4 fg__col-md-6 fg__col-sm-12">
                    <div className="content-container content-container--bordered background-white">
                      <div className="two-three-rows__image-container two-three-rows__image-container--bordered">
                        <img src={item.image ? item.image : "./assets/image-placeholder.png"} alt="" className="cover-image"/>
                      </div>
                      <div className="two-three-rows__card-text two-three-rows__card-text--bordered">
                        <h2 className="two-three-rows__item-title">{item.title}</h2>
                        <div className="mb36">
                          <ContentRenderer
                            contentType={item.content.type}
                            value={item.content.value}
                          />
                        </div>
                        <ContentLinkRenderer
                          contentType={item.detailContent.type}
                          value={item.detailContent.value}
                          linkContent="Learn"
                          className="learn-more-link"
                          target={item.detailContent.target}
                          pathForItem={this.props.pathForItem}
                          id={item.id}
                        />
                      </div>
                    </div>
                  </div>
                )
              })
          }
        </div>
      </div>
    )
  };
  
  getListView = (shouldShowOnlyArchivedItems = false) => {
    
    if (!this.props.layoutData) {
      return <Skeleton type="LONG_CONTENT_PAGE" />
    }
    
    // Retrieve years to show them as a titles
    const years = this.props.layoutData
      .filter((item) => {
        return shouldShowOnlyArchivedItems ? item.archived : !item.archived
      })
      .map((item) => { // extract years
        return item.date.split('/')[2];
      })
      .filter((item, index, array) => { // remove duplicates
        return array.indexOf(item) === index;
      })
      .sort((a, b) => {
        return b - a;
      });
    
    return (
      <BlankComponent>
        <div className="cards-list__archive-block-container">
          {
            years.length ? years.map((year, index) => {
              return (
                <div key={index} className="cards-list__archive-block">
                  <h3 className="cards-list__archive-year">{year}</h3>
                  
                  {/*Render and produce items per each year*/}
                  {this.props.layoutData
                    .filter((item) => { // Dynamically Filtering if there's only Archived items
                      return shouldShowOnlyArchivedItems ? item.archived : !item.archived
                    })
                    .filter((item) => {
                      const itemYear = item.date.split('/')[2];
                      return itemYear === year
                    })
                    .sort((a, b) => {
                      const timestampA = moment(a.date, 'MM/DD/YYYY').unix();
                      const timestampB = moment(b.date, 'MM/DD/YYYY').unix();
                      return timestampB - timestampA;
                    })
                    .map((item, index) => {
                      return (
                        <div key={index} className="cards-list__archive-item">
                          {
                            this.props.showDatesOfIndividualContent ? <p className="cards-list__archive-item-date">{item.date}</p> : null
                          }
                          <ContentLinkRenderer
                            contentType={item.detailContent.type}
                            value={item.detailContent.value}
                            linkContent={item.title}
                            className="cards-list__archive-item-title-link"
                            target={item.detailContent.target}
                            pathForItem={this.props.pathForItem}
                            id={item.id}
                            onEmptyContent={<p className="cards-list__archive-item-title-link mtn">{item.title}</p>}
                          />
                        </div>
                      )
                  })}
                </div>
              )
            }) : null
          }
        </div>
      </BlankComponent>
    )
  };
  
  getSwitcherDropdown = () => {
    if (this.props.hasViewSwitcher) {
      return (
        <div className="cards-list__select-wrapper">
          <Select
            hasPleaseSelectOption={false}
            name="filter"
            options={[
              {
                name: 'Most Recent',
              },
              {
                name: 'Archive',
              }
            ]}
            onChange={this.handleChange}
            desktopWidth={'100%'}
            tabletWidth={'100%'}
            mobileWidth={'100%'}
          />
        </div>
      )
    } else {
      return null
    }
  };
  
  getView = () => {
    if (this.state.selectedFilter === 'Most Recent') {
      return this.props.hasCardsView ? this.getCardsView() : this.getListView()
    } else {
      return this.getListView(true) // Show only archived items
    }
  };
  
  render() {
    const wrapperClass = this.props.wrapperClass ? this.props.wrapperClass : "cards-list";

    return (
      <BlankComponent>
        <div className={wrapperClass}>
          {this.getSwitcherDropdown()}
          {this.getView()}
        </div>
      </BlankComponent>
    );
  }
}

export default CardsList;

CardsList.propTypes = {
  layoutData: PropTypes.any,
  pathForItem: PropTypes.string,
  hasViewSwitcher: PropTypes.bool,
  showDatesOfIndividualContent: PropTypes.bool,
  hasCardsView: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/components/CardsList/CardsList.js